import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import { IS_LOCAL } from 'modules/common/const';

import App from './App';

const sentryDsnLink = import.meta.env.VITE_SENTRY_DSN;

if (!IS_LOCAL && sentryDsnLink) {
  Sentry.init({
    dsn: sentryDsnLink,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
    <StrictMode>
      <App />
    </StrictMode>
  </Sentry.ErrorBoundary>,
);
